import { DEFAULT_BASKET_ERROR_MESSAGE } from 'constants/basket';

enum BasketErrorCode {
  ItemOutOfStock = 'itemOutOfStock',
  PersonalisationIllegalCharacters = 'personalisationIllegalCharacters',
  PersonalisationTooLong = 'personalisationTooLong',
  ItemUnavailable = 'itemUnavailable',
}

const adaptATGBasketErrorMessage = (type: string): string => {
  switch (type) {
    case BasketErrorCode.PersonalisationIllegalCharacters:
      return 'Unable to add item to basket as the personalised field contains illegal characters';
    case BasketErrorCode.PersonalisationTooLong:
      return 'Personal message is too long';
    case BasketErrorCode.ItemOutOfStock:
      return 'Sorry, this item is out of stock';
    case BasketErrorCode.ItemUnavailable:
      return 'Sorry, this item is currently unavailable';
    default:
      return DEFAULT_BASKET_ERROR_MESSAGE;
  }
};

export default adaptATGBasketErrorMessage;
